<!-- 离场上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructureForThirdPark"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "abnormalOutReason": "",
                "abnormalOutRemark": "",
                "actualReceivable": 0,
                "amountReceivable": 16,
                "carLicenseNumber": "粤AL999B",
                "chargeState": 1,
                "confidence": 98,
                "correctConfidence": 0,
                "correctType": 0,
                "discountAmount": 16,
                "enterCarCardNumber": "",
                "enterCarColor": 0,
                "enterCarLicenseColor": 1,
                "enterCarLicenseNumber": "粤AL999B",
                "enterCarLicenseType": 0,
                "enterCarLogo": 0,
                "enterCarType": 1,
                "enterChannelCode": "0002",
                "enterChannelName": "南面临保入口",
                "enterCustomVipName": "",
                "enterNovipCode": 1,
                "enterRecognitionConfidence": 98,
                "enterSpeed": 0,
                "enterStatisticalArea": "0",
                "enterTime": "20190704120000",
            "addTime": "20190704130000",
                "enterType": 1,
                "enterVipRule": "",
                "enterVipType": 1,
                "extendInfo": {
                    "inEtcReliable": "0",
                    "inEtcCarCode": "",
                    "outEtcReliable": "0",
                    "selfInCode": "",
                    "enterNoVipCodeName": "正常",
                    "leaveNoVipCodeName": "正常",
                    "outEtcCode": "",
                    "selfInUserUniqCode": "",
                    "inEtcCode": "",
                    "outEtcCarCode": "",
                    "selfOutCode": "",
                    "selfOutUserUniqCode": ""
                },
                "inDriverPosPicId": "",
                "inOperatorName": "wdl",
                "inOperatorTime": "20190704120000",
                "isArrear": 0,
                "isCorrect": 0,
                "isManualMatch": 0,
                "lastCorrectLicenseNumber": "",
                "lastCorrectName": "",
                "leaveCarCardNumber": "",
                "leaveCarColor": 0,
                "leaveCarLicenseColor": 1,
                "leaveCarLicenseNumber": "粤AL999B",
                "leaveCarLicenseType": 0,
                "leaveCarLogo": 0,
                "leaveCarType": 1,
                "leaveChannelCode": "0004",
                "leaveChannelName": "北面临保出口",
                "leaveChargeGroupCode": "0",
                "leaveCustomVipName": "",
                "leaveNovipCode": 1,
                "leaveRecognitionConfidence": 96,
                "leaveSpeed": 0,
                "leaveStatisticalArea": "0",
                "leaveTime": "20190704130000",
                "leaveType": 1,
                "leaveVipRule": "",
                "leaveVipType": 1,
                "outDriverPosPicId": "",
                "outOperatorName": "wdl",
                "outOperatorTime": "20190704130000",
                "parkChargeDetailList": [
                    {
                        "actPayCharge": 0,
                        "billCode": "2019070413395095631346",
                        "collectorName": "wdl",
                        "couponList": [
                            {
                                "couponCode": "9NB77Q51O4S6H",
                                "couponName": "7月份1小时",
                                "couponOriginType": 1,
                                "couponType": 4,
                                "couponValue": 16
                            }
                        ],
                        "payDate": "20190704130000",
                        "payMode": 1,
                        "payOrigin": 1,
                        "payOriginRemark": "VEMS",
                        "platformShouldPay": 0,
                        "reliefCharge": 16
                    }
                ],
                "parkCode": "2KKN885S",
                "parkingCode": "190704120000313791823029",
                "platformShouldPay": 0,
                "realCharge": 0,
                "recordType": 1,
                "reliefCharge": 0,
                "remark": "9NB77Q51O4S6H,3600,1600,1;",
                "stoppingTime": 52,
                "tollCollectorName": "wdl",
                "tollCollectorTime": "20190704130000",
                "totalAmount": 16,
                "traderCouponList": [
                    {
                        "traderCouponGrantSn": "9NB77Q51O4S6H",
                        "traderCouponValue": 16
                    }
                ]
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统主动推送车辆离场信息到智慧停车开放平台",
                sdkcondition: "cmd='upThirdParkCarOut'",
                t_url: this.commonUrls.test + "upThirdParkCarOut",
                p_url: this.commonUrls.prod + "upThirdParkCarOut",
                precondition: "联系智慧停车管理员创建第三方车场",
                fitSystem: "第三方停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'carLicenseNumber', info2: '是', info3: 'String', info4: '最终车牌号' },
                        { info1: 'confidence', info2: '是', info3: 'Decimal', info4: '校正置信度。0-100' },
                        { info1: 'stoppingTime', info2: '是', info3: 'Integer', info4: '停车时长' },
                        { info1: 'totalAmount', info2: '是', info3: 'Decimal', info4: '停车费用' },
                        { info1: 'amountReceivable', info2: '是', info3: 'Decimal', info4: '应收金额' },
                        { info1: 'discountAmount', info2: '是', info3: 'Decimal', info4: '优惠金额' },
                        { info1: 'actualReceivable', info2: '是', info3: 'Decimal', info4: '实收金额' },
                        { info1: 'enterCarLicenseNumber', info2: '是', info3: 'String', info4: '进场时识别车牌号' },
                        { info1: 'enterCarCardNumber', info2: '否', info3: 'String', info4: '进场卡号' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间。yyyyMMddHHmmss' },
                        { info1: 'enterChannelName', info2: '是', info3: 'String', info4: '进入场通道名' },
                        { info1: 'enterChannelCode', info2: '是', info3: 'String', info4: '进场通道编号' },
                        { info1: 'enterVipType', info2: '否', info3: 'Integer', info4: '进场Vip类型	（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'enterType', info2: '是', info3: 'Integer', info4: '进场类型：<url>参考附录:/Api/appendixData</url>' },
                        { info1: 'enterSpeed', info2: '否', info3: 'Decimal', info4: '进场速度' },
                        { info1: 'enterCarLicenseColor', info2: '是', info3: 'Integer', info4: '进场车牌颜色' },
                        { info1: 'enterCarColor', info2: '是', info3: 'Integer', info4: '进场车辆颜色' },
                        { info1: 'enterCarLogo', info2: '是', info3: 'Integer', info4: '进场车标' },
                        { info1: 'enterCarLicenseType', info2: '是', info3: 'Integer', info4: '进场车牌类型' },
                        { info1: 'enterCarType', info2: '是', info3: 'Integer', info4: '车辆类型 0未知 1小车 2大车 3超大车 4中型车' },
                        { info1: 'enterRecognitionConfidence', info2: '是', info3: 'Decimal', info4: '进场识别置信度。0-100' },

                        { info1: 'leaveCarLicenseNumber', info2: '是', info3: 'String', info4: '出场车牌号' },
                        { info1: 'leaveCarCardNumber', info2: '否', info3: 'String', info4: '出场卡号' },
                        { info1: 'leaveTime', info2: '是', info3: 'String', info4: '出场时间。yyyyMMddHHmmss' },
                        { info1: 'leaveChannelName', info2: '是', info3: 'String', info4: '出场通道名' },
                        { info1: 'leaveChannelCode', info2: '是', info3: 'String', info4: '离场通道编号' },
                        { info1: 'leaveVipType', info2: '否', info3: 'Integer', info4: '进场Vip类型	（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'leaveType', info2: '是', info3: 'Integer', info4: '离场类型：<url>参考附录:/Api/appendixData</url>' },
                        { info1: 'leaveSpeed', info2: '否', info3: 'Decimal', info4: '离场速度' },
                        { info1: 'leaveCarLicenseColor', info2: '是', info3: 'Integer', info4: '离场车牌颜色' },
                        { info1: 'leaveCarColor', info2: '是', info3: 'Integer', info4: '离场车辆颜色' },
                        { info1: 'leaveCarLogo', info2: '是', info3: 'Integer', info4: '离场车标' },
                        { info1: 'leaveCarLicenseType', info2: '是', info3: 'Integer', info4: '离场车牌类型' },
                        { info1: 'leaveCarType', info2: '是', info3: 'Integer', info4: '车辆类型 0未知 1小车 2大车 3超大车 4中型车' },
                        { info1: 'leaveRecognitionConfidence', info2: '是', info3: 'Decimal', info4: '离场识别置信度。0-100' },

                        { info1: 'recordType', info2: '是', info3: 'Integer', info4: '记录类型	0未定义，1有牌车，2无牌车，3遮挡车，4非汽车，5误触发' },
                        { info1: 'isCorrect', info2: '是', info3: 'Integer', info4: '是否校正 车牌是否被纠正（0未纠正，1已纠正）' },
                        { info1: 'correctType', info2: '是', info3: 'Integer', info4: '校正类型	0未校正，1手动校正，2自动校正，后续详见校正表' },
                        { info1: 'correctConfidence', info2: '是', info3: 'Integer', info4: '校正置信度' },
                        { info1: 'lastCorrectLicenseNumber', info2: '是', info3: 'String', info4: '最后校正校正车牌' },
                        { info1: 'lastCorrectName', info2: '否', info3: 'String', info4: '最后校正人名' },
                        { info1: 'lastCorrectTime', info2: '是', info3: 'String', info4: '最后校正时间。yyyyMMddHHmmss' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'addTime', info2: '是', info3: 'String', info4: '记录添加时间。yyyyMMddHHmmss' },
                        { info1: 'inOperatorName', info2: '否', info3: 'String', info4: '放入操作员名' },
                        { info1: 'inOperatorTime', info2: '是', info3: 'String', info4: '放入操作时间。yyyyMMddHHmmss' },
                        { info1: 'outOperatorName', info2: '否', info3: 'String', info4: '放出操作员名' },
                        { info1: 'outOperatorTime', info2: '是', info3: 'String', info4: '放出操作时间。yyyyMMddHHmmss' },
                        { info1: 'tollCollectorName', info2: '否', info3: 'String', info4: '收费员' },
                        { info1: 'tollCollectorTime', info2: '是', info3: 'String', info4: '收费时间。yyyyMMddHHmmss' },

                        { info1: 'enterCustomVipName', info2: '否', info3: 'String', info4: '进场用户自定义VIP名称' },
                        { info1: 'leaveCustomVipName', info2: '否', info3: 'String', info4: '离场用户自定义VIP名称' },
                        { info1: 'abnormalOutReason', info2: '否', info3: 'String', info4: '异常放行原因' },
                        { info1: 'abnormalOutRemark', info2: '否', info3: 'String', info4: '异常放行备注' },
                        { info1: 'enterStatisticalArea', info2: '否', info3: 'String', info4: '进场统计区域	中括号包裹区域序号逗号分个，如[1],[5]' },
                        { info1: 'leaveStatisticalArea', info2: '否', info3: 'String', info4: '离场统计区域	用于统计（中括号包裹区域序号逗号分个，如[2],[6]）' },

                        { info1: 'enterNovipCode', info2: '是', info3: 'Integer', info4: '进场非VIP类型码 0未知，1正常，2VIP转临时车，3没有通道权限' },
                        { info1: 'leaveNovipCode', info2: '是', info3: 'Integer', info4: '出场非VIP类型码	（0未知，1正常，2VIP转临时车，3没有通道权限，4在场转临时车，5在场转VIP车）' },
                        { info1: 'isManualMatch', info2: '是', info3: 'Integer', info4: '是否手动匹配（0否，1是）' },

                        { info1: 'enterVipRule', info2: '否', info3: 'String', info4: '进场VIP类型编号' },
                        { info1: 'enterChannelCode', info2: '是', info3: 'String', info4: '进场通道编号' },
                        { info1: 'enterChargeGroupCode', info2: '否', info3: 'String', info4: '进场计费规则编号' },
                        { info1: 'leaveVipRule', info2: '否', info3: 'String', info4: '离场通道编号' },
                        { info1: 'leaveChannelCode', info2: '是', info3: 'String', info4: '离场通道编号' },
                        { info1: 'leaveChargeGroupCode', info2: '否', info3: 'String', info4: '离场计费规则编号' },

                        { info1: 'chargeState', info2: '是', info3: 'Integer', info4: '支付状态	0未支付，1支付' },
                        { info1: 'realCharge', info2: '是', info3: 'Decimal', info4: '线下总实付' },
                        { info1: 'reliefCharge', info2: '是', info3: 'Decimal', info4: '线下总优惠' },
                        { info1: 'platformShouldPay', info2: '是', info3: 'Decimal', info4: '线上余额应扣款' },

                        { info1: 'inDriverPosPicId', info2: '是', info3: 'String', info4: '进场驾驶位抓拍图片id' },
                        { info1: 'outDriverPosPicId', info2: '是', info3: 'String', info4: '离场驾驶位抓拍图片id' },

                        { info1: 'parkChargeDetailList', info2: '否', info3: 'JSONArray', info4: '支付账单列表' },
                        { info1: 'traderCouponList', info2: '否', info3: 'JSONArray', info4: '商家优惠信息' },
                        { info1: 'extendInfo', info2: '是', info3: 'JSONObject', info4: '附加信息' },
                        ]
                },{
                    titleName: 'parkChargeDetailList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '支付订单号' },
                        { info1: 'payDate', info2: '是', info3: 'String', info4: '支付时间，yyyyMMddHHmmss' },
                        { info1: 'actPayCharge', info2: '是', info3: 'Decimal', info4: '车主实付金额' },
                        { info1: 'reliefCharge', info2: '是', info3: 'Decimal', info4: '优惠金额' },
                        { info1: 'platformShouldPay', info2: '是', info3: 'Decimal', info4: '平台扣款' },
                        { info1: 'payMode', info2: '是', info3: 'Integer', info4: '支付方式，<url>参考附录:/Api/appendixData</url>' },
                        { info1: 'payOrigin', info2: '是', info3: 'Integer', info4: '支付来源，<url>参考附录:/Api/appendixData</url>' },
                        { info1: 'payModeRemark', info2: '是', info3: 'String', info4: '支付方式备注' },
                        { info1: 'payOriginRemark', info2: '是', info3: 'String', info4: '支付来源备注' },
                        { info1: 'collectorName', info2: '是', info3: 'String', info4: '收费员' },
                        { info1: 'desc', info2: '是', info3: 'String', info4: '描述' },
                        { info1: 'couponList', info2: '是', info3: 'JSONArray', info4: '优惠列表' }
                    ]
                },{
                    titleName: 'couponList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponValue', info2: '是', info3: 'Decimal', info4: '抵扣金额,实际的抵扣金额' },
                        { info1: 'couponOriginType', info2: '是', info3: 'Integer', info4: '优惠类型 0本地优惠 1商家优惠 2自动券优惠 3停车场线上优惠' },
                        { info1: 'couponType', info2: '是', info3: 'Integer', info4: '券类型 0免费券 1金额扣减券 2金额折扣券 3金额固定值券，车费按券的固定值结算 4时间券，时间减免后再按车费结算 5不同计价券,按不同计价规则车费结算 6时间段封顶券' },
                        { info1: 'couponName', info2: '是', info3: 'String', info4: '优惠名称' },
                        { info1: 'couponCode', info2: '是', info3: 'String', info4: '优惠券的编码' }
                    ]
                },{
                    titleName: 'traderCouponList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'traderCouponGrantSn', info2: '是', info3: 'String', info4: '抵扣的商家优惠券编码' },
                        { info1: 'traderCouponValue', info2: '是', info3: 'Decimal', info4: '商家券优惠抵扣金额' },
                        ]
                },{
                    titleName: 'extendInfo',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'selfInCode', info2: '是', info3: 'String', info4: '自助进场随机码' },
                        { info1: 'selfInUserUniqCode', info2: '是', info3: 'String', info4: '自助进场用户标识' },
                        { info1: 'inEtcCarCode', info2: '否', info3: 'String', info4: '进场ETC卡号' },
                        { info1: 'inEtcCode', info2: '否', info3: 'String', info4: '进场ETC车牌号' },
                        { info1: 'inEtcReliable', info2: '是', info3: 'String', info4: '入场ETC是否可信（0否，1是）。非ETC请设置为0' },
                        { info1: 'enterNoVipCodeName', info2: '否', info3: 'String', info4: '进场非VIP类型名称' },
                        { info1: 'selfOutCode', info2: '是', info3: 'String', info4: '自助离场随机码' },
                        { info1: 'selfOutUserUniqCode', info2: '是', info3: 'String', info4: '自助离场用户唯一编号' },
                        { info1: 'outEtcCarCode', info2: '否', info3: 'String', info4: '离场ETC卡号' },
                        { info1: 'outEtcCode', info2: '否', info3: 'String', info4: '离场ETC车牌号' },
                        { info1: 'outEtcReliable', info2: '是', info3: 'String', info4: '离场ETC是否可信（0否，1是）' },
                        { info1: 'leaveNoVipCodeName', info2: '否', info3: 'String', info4: '离场非VIP类型名' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForAke/upward/upThirdParkCarOut.vue